<template>
<div>
    <!-- modal -->
    <b-modal id="lawAuthorityRepresentativeFormModal" centered size="lg" no-close-on-backdrop ref="lawAuthorityRepresentativeFormModal" :title=" $t('lawAuthorityRepresentative.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
        <b-row>
            <b-col class="col-lg-6">
                            <b-form-group>
                                    <label>{{ $t('lawAuthorityRepresentative.law_authority_name')  }}</label>
                                    <b-form-select size="sm" v-model="lawAuthoritySelect" value-field="id" text-field="name" :options="lawAuthorityList" />
                            </b-form-group>
            </b-col>
            <b-col class="col-lg-6" >
                <b-form>
                <label>{{ $t('lawAuthorityRepresentative.type') }}</label>
                <b-form-group>
                    <validation-provider #default="{ errors }" :name=" $t('lawAuthorityRepresentative.type')" rules="required">
                        <b-form-input v-model="name" size="sm" maxlength="250" :state="errors.length > 0 ? false:null" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-form>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="col-lg-6">
                   <b-form>
                    <label>{{ $t('lawAuthorityRepresentative.address') }}</label>
                     <b-form-group>
                         <b-form-input  v-model="address" size="sm" maxlength="250" />
                     </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                   <b-form>
                    <label>{{ $t('lawAuthorityRepresentative.email') }}</label>
                     <b-form-group>
                         <b-form-input  v-model="email" size="sm" maxlength="50" />
                     </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-3">
                   <b-form>
                    <label>{{ $t('lawAuthorityRepresentative.phone_number') }}</label>
                     <b-form-group>
                         <b-form-input  v-model="phoneNumber" size="sm" maxlength="50" />
                     </b-form-group>
                    </b-form>
                </b-col>
        </b-row>
        <b-row>
                   <b-col class="col-lg-12">
                        <label>{{ $t('lawAuthorityRepresentative.note') }}</label>
                        <b-form-textarea :placeholder=" $t('lawAuthorityRepresentative.note')" rows="3" v-model="note" maxlength="250" />
                    </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getLawAuthorityRepresentativeList: {
            type: Function
        },
    },
    data() {
        return {
            id: 0,
            name: '',
            lawAuthorityList: [],
            lawAuthoritySelect: 0,
            note: '',
            address: '',
            phoneNumber: '',
            email: ''


        }
    },
    methods: {
        async showInfo(id) {
            this.$refs['lawAuthorityRepresentativeFormModal'].show()
            this.id = id

            const data = {id: this.id }
            const controller = {  name: 'LawAuthorityRepresentative'}
            const payload = { data: data,controller: controller  }

            const response = await this.$store.dispatch('moduleAuth/getInfo', payload)
                if (response.data.resultStatus == true) {
                    this.lawAuthorityList = response.data.lawAuthorityList
                    this.lawAuthorityList.splice(0, 0, this.$nullSelected())
                    this.lawAuthoritySelect = response.data.lawAuthorityRepresentative.lawAuthorityId
                    this.name = response.data.lawAuthorityRepresentative.name
                    this.note = response.data.lawAuthorityRepresentative.note
                    this.address = response.data.lawAuthorityRepresentative.address
                    this.phoneNumber = response.data.lawAuthorityRepresentative.phoneNumber
                    this.email = response.data.lawAuthorityRepresentative.email
                } else {
                    this.$bvModal.hide('lawAuthorityRepresentativeFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
           
        },
        async addOrUpdate() {

            const data = {
                 id: this.id, 
                 name: this.name,
                 lawAuthorityId: this.lawAuthoritySelect,
                 note: this.note,
                 address: this.address,
                 phoneNumber: this.phoneNumber,
                 email :this.email
                };

            const controller = {name: 'LawAuthorityRepresentative' }
            const payload = {  data: data, controller: controller }

            const success = await this.$refs.simpleRules.validate()
                if (success) {
                    const response = await this.$store.dispatch('moduleAuth/save', payload)
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('lawAuthorityRepresentativeFormModal')
                            this.getLawAuthorityRepresentativeList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                }
        }
    }
}
</script>
  
<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
